<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{ titleCard }}</h5>
    <button
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      (click)="onNo()"
    >
      <fa-icon [icon]="faClose"> </fa-icon>
    </button>
  </div>
  <div class="modal-body">
    <p *ngIf="titleCard !== 'Producto agotado'; else soldout">
      Para contactar por whatsapp con este proveedor llena los siguientes datos:
    </p>
    <ng-template #soldout>
      <p class="tex-body-description">
        Déjanos tu correo electrónico y te avisaremos en cuanto vuelva a estar
        disponible
      </p>
    </ng-template>
    <form [formGroup]="applicationFormGroup">
      <div class="form-group">
        <app-input-text
          type="text"
          label="Nombre"
          placeholder="Escriba su nombre aquí"
          frmControl="name"
          class_label="white"
          [formParent]="applicationFormGroup"
        ></app-input-text>
      </div>
      <div class="form-group">
        <app-input-text
          type="text"
          label="Apellido"
          placeholder="Escriba su apellido aquí"
          frmControl="lastname"
          class_label="white"
          [formParent]="applicationFormGroup"
        ></app-input-text>
      </div>
      <div class="form-group">
        <app-input-text
          type="text"
          label="Teléfono"
          placeholder="Escriba su teléfono aquí"
          frmControl="phone"
          class_label="white"
          [formParent]="applicationFormGroup"
        ></app-input-text>
      </div>
      <div class="form-group">
        <app-input-text
          type="text"
          label="Correo electrónico"
          placeholder="Escriba su correo aquí"
          frmControl="email"
          class_label="white"
          [formParent]="applicationFormGroup"
        ></app-input-text>
      </div>
      <div class="form-group">
        <div class="form-check d-flex align-items-center">
          <input
            type="checkbox"
            class="form-check-input"
            id="termsAccepted"
            formControlName="termsAccepted"
          />
          <label class="form-check-label textleft">
            <span>Acepto </span>
            <span class="greem">
              <a
                href="/home/terms-and-conditions"
                target="_blank"
              >
                términos y condiciones de uso
              </a>
            </span>
            <span>& </span>
            <span class="greem">
              <a
                href="/home/treatment-policy"
                target="_blank"
              >
                política de tratamiento de datos
              </a>
            </span>
          </label>
        </div>
        <div
          *ngIf="
            applicationFormGroup.get('termsAccepted')?.hasError('required') &&
            applicationFormGroup.get('termsAccepted')?.touched
          "
          class="text-danger"
        >
          Debes aceptar los términos y condiciones.
        </div>
      </div>
      <button
        type="submit"
        class="btn btn-primary btn-block"
        (click)="postApplication()"
        [disabled]="applicationFormGroup.invalid"
      >
        Continuar
      </button>
    </form>
  </div>
</div>
